import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "card mb-2",
  style: {"height":"100%"}
}
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "text-justify" }
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  "svg-inline": '',
  class: /*#__PURE__*/_normalizeClass('icon'),
  role: 'presentation',
  focusable: 'false',
  tabindex: '-1'
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("path", { d: "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v242.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-32c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 104c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  "svg-inline": '',
  class: /*#__PURE__*/_normalizeClass('icon'),
  role: 'presentation',
  focusable: 'false',
  tabindex: '-1'
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("path", { d: "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208-93.3 208-208 208zm40-128h-16v-88c0-13.2-10.7-24-24-24h-32c-13.2 0-24 10.8-24 24s10.8 24 24 24h8v64h-16c-13.2 0-24 10.8-24 24s10.8 24 24 24h80c13.25 0 24-10.75 24-24s-10.7-24-24-24zm-40-144c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.3-32 32 14.3 32 32 32z" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["href"]
const _hoisted_19 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  "svg-inline": '',
  class: /*#__PURE__*/_normalizeClass('icon'),
  role: 'presentation',
  focusable: 'false',
  tabindex: '-1'
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("path", { d: "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208-93.3 208-208 208zm0-128c-18 0-32 14-32 32s13.1 32 32 32c17.1 0 32-14 32-32s-14.9-32-32-32zm33.1-208H238c-39 0-70 31-70 70 0 13 11 24 24 24s24-11 24-24c0-12 9.1-22 21.1-22h51.1c12.9 0 23.8 10 23.8 22 0 8-4 14.1-11 18.1L244 251c-8 5-12 13-12 21v16c0 13 11 24 24 24s24-11 24-24v-2l45.1-28c21-13 34-36 34-60 .9-39-30.1-70-70-70z" }, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = ["href"]
const _hoisted_23 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  "svg-inline": '',
  class: /*#__PURE__*/_normalizeClass('icon'),
  role: 'presentation',
  focusable: 'false',
  tabindex: '-1'
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("path", { d: "M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64h185.4c2.2 20.4 3.3 41.8 3.3 64zm28.8-64h123.1c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6 78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7 10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5 11.6 26 21 58.2 27 94.7zm-209 0H18.6c30-74.1 93.6-130.9 172-151.6-25.5 34.2-45.3 87.7-55.3 151.6zM8.1 192h123.1c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zm186.6 254.6c-11.6-26-20.9-58.2-27-94.6h176.6c-6.1 36.4-15.5 68.6-27 94.6-10.5 23.6-22.2 40.7-33.5 51.5-11.2 10.7-20.5 13.9-27.8 13.9s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6-78.4-20.7-142-77.5-172-151.6h116.7zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6 25.5-34.2 45.2-87.7 55.3-151.6h116.6z" }, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = ["href"]
const _hoisted_27 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  "svg-inline": '',
  class: /*#__PURE__*/_normalizeClass('icon'),
  role: 'presentation',
  focusable: 'false',
  tabindex: '-1'
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("path", { d: "M22.2 32A16 16 0 006 47.8a26.4 26.4 0 00.2 2.8l67.9 412.1a21.8 21.8 0 0021.3 18.2h325.7a16 16 0 0016-13.4L505 50.7a16 16 0 00-13.2-18.3 24.6 24.6 0 00-2.8-.2L22.2 32zm285.9 297.8h-104l-28.1-147h157.3l-25.2 147z" }, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = ["src", "alt"]
const _hoisted_32 = ["src", "alt"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h2", null, "Do you have comments? Questions?", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HtmlMeta = _resolveComponent("HtmlMeta")!
  const _component_MarkDown = _resolveComponent("MarkDown")!
  const _component_Disqus = _resolveComponent("Disqus")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HtmlMeta, {
      title: this.extension.name,
      description: this.extension.intro,
      image: this.imageUrl(),
      url: 'https://n3t.bitbucket.io' + this.$route.path,
      type: "product",
      schema: _ctx.schema()
    }, null, 8, ["title", "description", "image", "url", "schema"]),
    _createElementVNode("div", _hoisted_1, [
      (!this.extension.legacyIcon)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: this.imageUrl(),
            class: "card-img-top",
            alt: this.extension.name
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (this.extension.legacyIcon)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: this.imageUrl(),
              alt: this.extension.name
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("h2", _hoisted_5, _toDisplayString(this.extension.name), 1),
        _createElementVNode("p", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.extension.badges, (badge) => {
            return (_openBlock(), _createElementBlock("span", { key: badge }, [
              _createElementVNode("img", {
                src: this.badge(badge),
                alt: badge
              }, null, 8, _hoisted_6),
              _createTextVNode(" " + _toDisplayString(' '))
            ]))
          }), 128)),
          (this.extension.docProject)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: this.extension.docLink
              }, [
                _createElementVNode("img", {
                  src: 'https://readthedocs.org/projects/' + this.extension.docProject + '/badge/?version=latest',
                  alt: "Documentation status"
                }, null, 8, _hoisted_8)
              ], 8, _hoisted_7))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("p", _hoisted_9, _toDisplayString(this.extension.intro), 1),
        _createElementVNode("p", null, [
          _createElementVNode("a", {
            href: this.extension.downloadLink,
            class: "btn btn-success btn-lg mb-2 mb-sm-0 w-100 w-sm-auto"
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_11, _hoisted_13)),
            _createTextVNode(" Downloads")
          ], 8, _hoisted_10),
          _createTextVNode(" " + _toDisplayString(' ') + " "),
          _createElementVNode("a", {
            href: this.extension.docLink + 'about/release-notes/',
            class: "btn btn-outline-secondary btn-lg mb-2 mb-sm-0 w-100 w-sm-auto"
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_15, _hoisted_17)),
            _createTextVNode(" Release notes")
          ], 8, _hoisted_14),
          _createTextVNode(" " + _toDisplayString(' ') + " "),
          _createElementVNode("a", {
            href: this.extension.docLink,
            class: "btn btn-outline-info btn-lg mb-2 mb-sm-0 w-100 w-sm-auto"
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_19, _hoisted_21)),
            _createTextVNode(" Documentation")
          ], 8, _hoisted_18),
          _createTextVNode(" " + _toDisplayString(' ') + " "),
          (this.extension.hasI18n)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: this.extension.docLink + 'about/translations/',
                class: "btn btn-outline-success btn-lg mb-2 mb-sm-0 w-100 w-sm-auto"
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_23, _hoisted_25)),
                _createTextVNode(" Translations")
              ], 8, _hoisted_22))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(' ') + " "),
          (this.extension.link)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: this.extension.link,
                class: "btn btn-outline-secondary btn-lg mb-2 mb-sm-0 w-100 w-sm-auto"
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_27, _hoisted_29)),
                _createTextVNode(" Repository")
              ], 8, _hoisted_26))
            : _createCommentVNode("", true)
        ]),
        (this.extension.version || this.extension.releaseDate)
          ? (_openBlock(), _createElementBlock("p", _hoisted_30, [
              (this.extension.version)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: this.versionBadge,
                    alt: this.extension.version
                  }, null, 8, _hoisted_31))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(' ') + " "),
              (this.extension.releaseDate)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: this.releaseDateBadge,
                    alt: this.extension.releaseDate
                  }, null, 8, _hoisted_32))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (this.description)
          ? (_openBlock(), _createBlock(_component_MarkDown, {
              key: 2,
              source: this.description
            }, null, 8, ["source"]))
          : _createCommentVNode("", true),
        _hoisted_33,
        _createVNode(_component_Disqus, {
          shortname: "n3tcz",
          pageConfig: this.disqusConfig
        }, null, 8, ["pageConfig"])
      ])
    ])
  ], 64))
}